module.exports = __webpack_public_path__ + "static/CYL-0c1741eee14f9ced700fe7e88b07f5eb.mp4";